import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  cx: "100",
  cy: "100",
  r: "100",
  fill: "url('#circleGradientExpired')"
}
const _hoisted_2 = {
  key: 1,
  cx: "100",
  cy: "100",
  r: "100",
  fill: "url('#circleGradient')"
}
const _hoisted_3 = { fill: "currentColor" }
const _hoisted_4 = {
  key: 0,
  y: "38%",
  transform: "translate(0, 2)",
  "font-size": "11"
}
const _hoisted_5 = {
  x: "50%",
  "text-anchor": "middle",
  class: "graph-text"
}
const _hoisted_6 = ["transform", "font-size"]
const _hoisted_7 = {
  x: "50%",
  "text-anchor": "middle",
  class: "graph-text"
}
const _hoisted_8 = {
  key: 1,
  y: "68%",
  transform: "translate(0, 2)",
  "font-size": "11"
}
const _hoisted_9 = ["stroke", "stroke-dasharray"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    class: _normalizeClass({'graph-shadow': !_ctx.expired, 'graph-shadow-expired': _ctx.expired})
  }, [
    _cache[1] || (_cache[1] = _createStaticVNode("<defs><linearGradient id=\"textGradient\" gradientTransform=\"rotate(90)\"><stop class=\"text-top\" offset=\"10%\"></stop><stop class=\"text-bottom\" offset=\"90%\"></stop></linearGradient><radialGradient id=\"circleGradientExpired\"><stop offset=\"49.9%\" class=\"graph-background\"></stop><stop offset=\"50%\" class=\"graph-internal5\"></stop><stop offset=\"54%\" class=\"graph-internal6\"></stop><stop offset=\"58%\" class=\"graph-internal5\"></stop><stop offset=\"58.1%\" class=\"graph-background\"></stop><stop offset=\"68%\" class=\"graph-background\"></stop><stop offset=\"68.1%\" class=\"graph-internal3\"></stop><stop offset=\"74%\" class=\"graph-internal4\"></stop><stop offset=\"80%\" class=\"graph-internal3\"></stop><stop offset=\"80.1%\" class=\"graph-background\"></stop><stop offset=\"87%\" class=\"graph-background\"></stop><stop offset=\"87.1%\" class=\"graph-expired\"></stop><stop offset=\"92%\" class=\"graph-expired-light\"></stop><stop offset=\"97%\" class=\"graph-expired\"></stop><stop offset=\"97.1%\" class=\"graph-expired-light\"></stop><stop offset=\"98%\" class=\"graph-expired-light\"></stop><stop offset=\"98.1%\" class=\"graph-expired\"></stop><stop offset=\"100%\" class=\"graph-expired\"></stop></radialGradient><radialGradient id=\"circleGradient\"><stop offset=\"49.9%\" class=\"graph-background\"></stop><stop offset=\"50%\" class=\"graph-internal5\"></stop><stop offset=\"54%\" class=\"graph-internal6\"></stop><stop offset=\"58%\" class=\"graph-internal5\"></stop><stop offset=\"58.1%\" class=\"graph-background\"></stop><stop offset=\"68%\" class=\"graph-background\"></stop><stop offset=\"68.1%\" class=\"graph-internal3\"></stop><stop offset=\"74%\" class=\"graph-internal4\"></stop><stop offset=\"80%\" class=\"graph-internal3\"></stop><stop offset=\"80.1%\" class=\"graph-background\"></stop><stop offset=\"87%\" class=\"graph-background\"></stop><stop offset=\"87.1%\" class=\"graph-internal1\"></stop><stop offset=\"92%\" class=\"graph-internal2\"></stop><stop offset=\"97%\" class=\"graph-internal1\"></stop><stop offset=\"97.1%\" class=\"graph-background\"></stop><stop offset=\"98%\" class=\"graph-background\"></stop><stop offset=\"98.1%\" class=\"graph-external\"></stop><stop offset=\"100%\" class=\"graph-external\"></stop></radialGradient></defs>", 1)),
    _createCommentVNode(" using my radial gradient "),
    (_ctx.expired)
      ? (_openBlock(), _createElementBlock("circle", _hoisted_1))
      : (_openBlock(), _createElementBlock("circle", _hoisted_2)),
    _createElementVNode("g", _hoisted_3, [
      (!_ctx.small && !_ctx.sorn)
        ? (_openBlock(), _createElementBlock("text", _hoisted_4, [
            _createElementVNode("tspan", _hoisted_5, _toDisplayString(_ctx.formattedLabel), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("text", {
        y: "50%",
        transform: _ctx.sorn ? 'translate(0, 10)' : 'translate(0, 16)',
        "font-size": _ctx.dueLabelFontSize,
        "font-weight": "bold",
        "font-family": "TradeGothicLT",
        fill: "url('#textGradient')"
      }, [
        _createElementVNode("tspan", _hoisted_7, _toDisplayString(_ctx.dueLabel), 1 /* TEXT */)
      ], 8 /* PROPS */, _hoisted_6),
      (!_ctx.small && !_ctx.sorn)
        ? (_openBlock(), _createElementBlock("text", _hoisted_8, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("tspan", {
              x: "50%",
              "text-anchor": "middle",
              class: "graph-text"
            }, "DAYS", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.days > 0)
      ? (_openBlock(), _createElementBlock("circle", {
          key: 2,
          cx: "100",
          cy: "100",
          stroke: _ctx.graphColor,
          r: "74",
          fill: "none",
          "stroke-width": "6%",
          "stroke-linecap": "round",
          "stroke-dasharray": _ctx.currentDashArray,
          "stroke-dashoffset": "116"
        }, null, 8 /* PROPS */, _hoisted_9))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}